import React,{useState} from 'react'
import SalesInvoiceForm from './SalesInvoiceForm';
import SalesInvoiceList from './SalesInvoiceList';

const SalesInvoice = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <SalesInvoiceForm addForm={setFromIsShown} update={upData} />
      ) : (
        <SalesInvoiceList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
)
}
export default SalesInvoice